<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch center; align-items: stretch; height:100%">
  <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch flex-start; align-items: stretch; flex: 1 1 100%; max-width: 50%;">
    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 8%">
    </div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
          <mat-toolbar color="primary" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;" class="toolbar-over-card">
            <div style="box-sizing: border-box; display: flex; place-content: center flex-start; align-items: center;">
              <span *ngIf="!currentCaseIsDeleted">
                <a routerLink="/dashboard" mat-button style="width: 30px; min-width: 30px; text-align:left; padding:0;">
                  <mat-icon>arrow_back</mat-icon>
                </a>
              </span>
              <div>Select case</div>
            </div>
            <div style="place-content: center flex-end; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
              <div *ngIf="isSearch" style="font-size: 12px; display: flex;">
                <mat-form-field>
                  <mat-label>Search for a case</mat-label>
                  <input matInput placeholder="" #searchBox id="search-box" (keyup)="updateSearchText(searchBox.value)" autofocus />
                  <button mat-icon-button [ngStyle]="{'visibility': searchBox?.value ? 'visible': 'hidden' }" matSuffix mat-icon-button aria-label="Clear" 
                  (click)="searchBox.value=''; updateSearchText(searchBox.value)" id="cancel-search-button">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <button mat-icon-button (click)="showSearch()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
          </mat-toolbar>

          <div style="max-height: 800px;">
            <mat-card style="height: 78vh; padding: 0;">
              <mat-card-content style="height: calc(100% - 80px); overflow: auto;">
                <mat-action-list class="dense" style="--level: 0">
                  <mat-list-item *ngFor="let case of cases" (click)="setCase(case)" style="height: 56px;">
                    <div matLine>
                      <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center space-between; align-items: center;">
                        <div class="mat-subtitle-2">{{case.caseName || '(no name)'}}</div>
                        <div class="mat-subtitle-2">{{case.caseDocCount | number}} document{{(case.caseDocCount !== 1) ? 's' : ''}}</div>
                      </div>
                    </div>
                    <div matLine>
                      <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch space-between; align-items: stretch;">
                        <span class="mat-body"> {{(case.account) ? 'Account: ' + case.account.accountName : ''}} </span>
                        <span class="mat-body"> {{(case.leadAttorney) ? 'Attorney: ' + case.leadAttorney : ''}} </span>
                      </div>
                    </div>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                </mat-action-list>
              </mat-card-content>
              <div align="right">
                <mat-paginator [length]="total"
                               [pageSize]="pageSize"
                               [pageSizeOptions]="pageSizeOptions"
                               class="dense" style="--level: -5">
                </mat-paginator>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 8%">
    </div>
  </div>
</div>
